import { render, staticRenderFns } from "./ViewCabinet.vue?vue&type=template&id=779c7683&lang=pug&"
import script from "./ViewCabinet.vue?vue&type=script&lang=js&"
export * from "./ViewCabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports